import {
  BondsBondCCurrencyCode,
  BondsBondGesRatValSpShortcut,
  BondsBondSAccIntRate,
  BondsBondSAccOblEndDate,
  BondsBondSMarketQtMin,
  BondsBondSMarketGrossYield,
  BondsBondSQuotePrice,
} from '../../../../../../../../../../../../../../../../../../../../../../../actor/api/Services/bonds';

export const linkedBondsElementDetailsValue = {
  'S_ACC.INT_RATE': BondsBondSAccIntRate,
  'S_ACC.OBL_END_DATE': BondsBondSAccOblEndDate,
  'S_QUOTE.PRICE_CLOSE': BondsBondSQuotePrice,
  'S_MARKET.YIELD': BondsBondSMarketGrossYield,
  'S_MARKET.QT_MIN': BondsBondSMarketQtMin,
  'C_CURRENCY.CODE': BondsBondCCurrencyCode,
  'GES_RAT_VAL_SP.SHORTCUT': BondsBondGesRatValSpShortcut,
};
